import { render, staticRenderFns } from "./quarter_card.vue?vue&type=template&id=0c314d10&scoped=true&"
import script from "./quarter_card.vue?vue&type=script&lang=js&"
export * from "./quarter_card.vue?vue&type=script&lang=js&"
import style0 from "./quarter_card.vue?vue&type=style&index=0&id=0c314d10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c314d10",
  null
  
)

export default component.exports